import { IShowEventHint } from '../../../actions/bookingCalendar/event/showEventHint'
import { IBookingCalendarStore } from '../index'

export default function(
  state: IBookingCalendarStore,
  action: IShowEventHint,
): IBookingCalendarStore {
  return {
    ...state,
    eventHint: {
      ...state.eventHint,
      anchorEvent: action.anchorEvent,
      id: action.eventId,
      open: true,
    },
  }
}
